export class NaturaRichiedenteDTO {
	codice: string;
	codiceTipoDeposito: string;
	descrizione: string;
	tipoPersona: Array<string>;
	dittaIndividuale: boolean;
	//TODO
	// tipoPersona: ['PF', 'PG'];
	// tipoPersona: 'PF' | 'PGF';
}